import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        padding: 40,
        backgroundColor: '#FFFFFF',
        fontFamily: 'Helvetica'
    },
    // En-tête gouvernemental
    governmentHeader: {
        marginBottom: 30,
        textAlign: 'center',
        backgroundColor: '#F8F9FA',
        padding: 15,
        borderRadius: 5
    },
    governmentTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 8,
        textTransform: 'uppercase',
        color: '#1A237E'  // Bleu foncé pour l'aspect officiel
    },
    ministryTitle: {
        fontSize: 14,
        marginBottom: 15,
        textTransform: 'uppercase',
        color: '#455A64'  // Bleu gris
    },
    // En-tête Niger Voyage
    header: {
        backgroundColor: '#1B5E20',  // Vert du drapeau nigérien
        padding: 20,
        marginBottom: 30,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 8,
        borderBottomWidth: 4,
        borderBottomColor: '#FFA000'  // Orange du drapeau nigérien
    },
    headerLeft: {
        flex: 1
    },
    headerTitle: {
        color: '#FFFFFF',
        fontSize: 28,
        fontWeight: 'bold',
        letterSpacing: 1
    },
    subTitle: {
        color: '#FFFFFF',
        fontSize: 14,
        marginTop: 8,
        opacity: 0.9
    },
    reference: {
        backgroundColor: '#FFFFFF',
        padding: 12,
        borderRadius: 6,
        alignItems: 'center',
        borderWidth: 2,
        borderColor: '#FFA000'
    },
    referenceText: {
        color: '#1B5E20',
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: 0.5
    },
    // Conteneur principal
    contentContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 20,
        justifyContent: 'space-between',
        marginBottom: 20
    },
    // Sections
    section: {
        width: '47%',  // Légèrement réduit pour avoir plus d'espace entre les sections
        marginBottom: 20,
        padding: 15,
        backgroundColor: '#FFFFFF',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E0E0E0',
        borderLeftWidth: 4,
        borderLeftColor: '#1B5E20',
        // Ajout d'une ombre (simulée avec un fond légèrement plus foncé)
        backgroundColor: '#FAFAFA'
    },
    sectionTitle: {
        color: '#1B5E20',
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 12,
        borderBottomWidth: 2,
        borderBottomColor: '#E0E0E0',
        paddingBottom: 8,
        letterSpacing: 0.5
    },
    // Lignes de données
    row: {
        marginBottom: 8,
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 3
    },
    label: {
        width: '40%',
        fontSize: 11,
        color: '#455A64',
        fontWeight: 'bold'
    },
    value: {
        flex: 1,
        fontSize: 11,
        color: '#212121',
        paddingLeft: 8
    },
    // QR Code
    qrSection: {
        position: 'absolute',
        bottom: 40,
        right: 40,
        width: 100,
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        padding: 10,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E0E0E0'
    },
    qrCode: {
        width: 80,
        height: 80
    },
    qrText: {
        fontSize: 9,
        color: '#455A64',
        textAlign: 'center',
        marginTop: 4
    },
    // Pied de page
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: '#455A64',
        fontSize: 10,
        paddingHorizontal: 40,
        borderTopWidth: 1,
        borderTopColor: '#E0E0E0',
        paddingTop: 15
    },
    dateText: {
        fontSize: 10,
        color: '#666666',
        marginTop: 4
    },
    divider: {
        height: 1,
        backgroundColor: '#E0E0E0',
        marginVertical: 15
    },
    importantValue: {
        color: '#1B5E20',
        fontWeight: 'bold'
    },
    warningText: {
        color: '#FFA000',
        fontSize: 10,
        marginTop: 5,
        fontStyle: 'italic'
    }
});

export default styles;